import {DeliveryType, UserAddress} from "../types/Delivery.interface.ts";

export enum OrderDeliveryType {
    transport_company = 'transport_company',
    in_town = 'in_town',
}

export function getOrderDeliveryType(userAddress: UserAddress): string {
    return userAddress.point.townId !== userAddress.townId ? OrderDeliveryType.transport_company : OrderDeliveryType.in_town;
}

export function getDeliveryTypeDescription(deliveryType: string): string {
    if(deliveryType === DeliveryType.shipping) return 'транспортной компанией';
    if(deliveryType === DeliveryType.pickup) return  'самовывоз';
    if(deliveryType === DeliveryType.courier) return 'курьером';
    return '';
}